import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // These datasets are low-churn and every mutation invalidates its own
      // queries, so a long staleTime is safe and cuts refetch egress: a
      // screen refocus inside this window serves cache instead of hitting
      // the API.
      staleTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
